import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { TutorialDialogComponent } from '@cpd-app/core-module/components/tutorial-dialog/tutorial-dialog.component';
import { GoalFacade } from '@cpd-app/state/goal';
import { UserProfileFacade } from '@cpd-app/state/user-profile';
import { combineLatest, delay, filter, map, withLatestFrom } from 'rxjs';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { ComponentBase } from '@cpd-app/shared-module/components/base';
import { CognitoAuthFacade } from '@cpd-app/state/cognito-auth';

import { MessageComponent } from '../../../shared-module/components/message/message.component';

@Component({
  selector: 'cpd-tutorial-button',
  templateUrl: './tutorial-button.component.html',
  styleUrls: ['./tutorial-button.component.scss']
})
export class TutorialButtonComponent extends ComponentBase implements OnInit {
  public countStepComplete$ = combineLatest([
    this.userProfileFacade.isAllSurveyComplete$,
    this.goalFacade.isCareerGoalSet$,
    this.goalFacade.isAcademicInstitutionProgramGoalSet$,
    this.goalFacade.isEnableToGetReturnLink$
  ]).pipe(
    map((data) => {
      return data.filter((item) => !item).length;
    })
  );

  private remindRef: MatSnackBarRef<MessageComponent>;

  constructor(
    private dialog: MatDialog,
    private goalFacade: GoalFacade,
    private configFacade: CognitoAuthFacade,
    private userProfileFacade: UserProfileFacade,
    private snackBar: MatSnackBar
  ) {
    super();
  }

  public ngOnInit(): void {
    this.subscribedTo = this.goalFacade.isEnableToGetReturnLink$
      .pipe(
        withLatestFrom(
          this.goalFacade.reportDownloaded$,
          this.goalFacade.reportShared$,
          this.configFacade.isAuthenticated$
        ),
        filter(
          ([isEnableDownload, downloaded, shared, isAuthenticated]) =>
            isEnableDownload && !isAuthenticated && !downloaded && !shared
        ),
        delay(2000)
      )
      .subscribe(() => {
        this.openRemind();
      });
  }

  public onClick(): void {
    const config: MatDialogConfig = {
      width: '400px',
      position: {
        right: '50px'
      },
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop'
    };
    if (this.isMobileView) {
      delete config.position;
    }

    this.dialog.open(TutorialDialogComponent, config);
  }

  private openRemind(): void {
    if (this.remindRef) {
      return;
    }

    this.remindRef = this.snackBar.openFromComponent(MessageComponent, {
      horizontalPosition: 'right',
      verticalPosition: 'top',
      duration: 5000,
      panelClass: 'remind',
      data: {
        title: `Don’t forget to save your progress!`,
        content: `Login, email your return link to yourself or download your goals report so that you can re-visit your work / make changes.`,
        closeFn: () => {
          this.remindRef.dismiss();
        }
      }
    });
  }
}
